
export const addToast = (message) => async (dispatch) => {
  dispatch({ type: 'ADD_TOAST', payload: message });
}

export const showLoading = (message) => async (dispatch) => {
  dispatch({ type: 'LOADING', payload: true });
}

export const hideLoading = (message) => async (dispatch) => {
  dispatch({ type: 'LOADING', payload: false });
}

export const showContactUs = (propertyId, type, title) => async (dispatch) => {
  dispatch({ type: 'IS_DRAWER_OPEN', payload: {show: true, propertyId, type, title} });
}

export const hideContactUs = () => async (dispatch) => {
  dispatch({ type: 'IS_DRAWER_OPEN', payload: {show: false, propertyId: null, type: 'enquiry', title: 'Talk to Agent'} });
}

export const showAskForLogin = (showLogin) => async (dispatch) => {
  dispatch({ type: 'ASK_FOR_LOGIN', payload: showLogin });
}
export const showResponsePopup = (requestId) => async (dispatch) => {
  dispatch({ type: 'OPEN_RESPONSE_POPUP', payload: {show: true, requestId: requestId, type: 'request', title: 'Respond to the request'} });
}

export const hideResponsePopup = () => async (dispatch) => {
  dispatch({ type: 'OPEN_RESPONSE_POPUP', payload: {show: false, requestId: null, type: 'request', title: 'Respond to the request'} });
}